import {Settlement, SettlementEntity} from "../../../model/settlement";
import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export type SettlementSelectorProps = {
  // selector props here
};

export const settlementsSelector = () => createSelector(
  [getUseQueryResultData<Settlement[]>],
  (data) => {
    return selectSettlementsAndTransform(
      data ?? [], {}
    );
  }
);

export const settlementSelector = () => createSelector(
  [getUseQueryResultData<Settlement>],
  (data) => {
    return data ? transformSettlement(data) : undefined;
  }
);

export const selectSettlements = (values?: Settlement[], selector?: SettlementSelectorProps): Settlement[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;
    return filterIn;
  });
};

export const transformSettlement = (value: Settlement): SettlementEntity => {
  return SettlementEntity.from(value)
}

export const selectSettlementsAndTransform = (values?: Settlement[], selector?: SettlementSelectorProps): SettlementEntity[] => {
  const selected = selectSettlements(values, selector);
  return selected.map(transformSettlement);
};
